import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Loading from 'vue3-loading-overlay/dist/index';

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingDialog',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Loading), {
    color: "var(--color-primary)",
    "is-full-page": false,
    width: 30,
    height: 30,
    active: ""
  }))
}
}

})